import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Masthead } from '../components/Masthead'

/**
 * 404 fallback for unmatched routes (wired as the router catch-all `*` and as
 * the top-level errorElement). Standalone — mirrors the Login masthead/card so
 * it renders in any auth state and never exposes React Router's raw dev error
 * boundary. Old legacy URLs (e.g. the FastAPI `/app` path) land here.
 */
export function NotFound() {
  const { t } = useTranslation()
  return (
    <div className="wrap">
      <Masthead />

      <section className="auth-card">
        <div className="auth-card__inner">
          <div className="auth-card__label">
            {t('notFound.code')} · {t('notFound.title')}
          </div>
          <p className="auth-card__lede">{t('notFound.lede')}</p>
          <Link to="/" className="auth-card__btn">
            {t('notFound.home')}
          </Link>
        </div>
      </section>
    </div>
  )
}
